import React from 'react';

export class DropdownBaseDataControl extends React.Component {

    constructor(props) {
        super(props);

        if (!this.props.dataManager) {
            throw new Error("ControlDataManager Property is required");
        }

        if (!this.props.propertyName) {
            throw new Error("PropertyName Property is required");
        }

        this.metaData = null;
        this.currentValue = -1
        this.selectedItem = null;
        this.dataSourceItems = null;

        this.state = {
            items: [],
            value: this.currentValue,
            defaultSelectedId: -1,
            valueMemberName: null,
            displayMemberName: null
        }

        this.dataManager = this.props.dataManager;
        this.dataManager.register(this);
        this.onChange = this.onChange.bind(this);
    }

    init(metaData) {
        var self = this;
        this.metaData = metaData;
        return new Promise(function (resolve, reject) {
            resolve(self);
        });
    }

    componentDidMount() {
        this.dataManager.bindControl(this.props.propertyName);
    }

    componentWillUnmount() {
        this.dataManager.unbindControl(this.props.propertyName);
    }

    setValue(value) {
        this.selectedItem = null;

        var valueField = this.metaData?.dataSourceData?.valueMemberName ? this.metaData.dataSourceData.valueMemberName : 'id';

        var newValue = value && value >= 0 ? value : -1
        var items = this.dataSourceItems;

        if (newValue >= 0 && items) {
            this.selectedItem = items.find(e => e[valueField] === newValue);
            if (!this.selectedItem) {
                newValue = -1;
            }
        }

        this.setState({
            value: newValue
        });

        this.currentValue = newValue;
        this.reportChange(newValue, this.selectedItem);
    }

    getValue() {
        return this.state.value >= 0 ? this.state.value : null;
    }

    isInputValid() {
        var result = true;
        var validationData = this.metaData && this.metaData.validationData ? this.metaData.validationData : null;
        if (validationData) {
            if (validationData.required === true && this.currentValue < 0) {
                result = false;
            }
        }
        return result;
    }

    // work with both event or value
    onChange(event, newValue) {
        var v = event ? parseInt(event.target.value) : newValue;  // takes value when even is null
        var value = v >= 0 ? v : null;
        this.setValue(value);

        var valueMemberName = this.metaData?.dataSourceData?.valueMemberName ? this.metaData?.dataSourceData?.valueMemberName : 'id';

        var idx = this.state.items.findIndex(item => {
            return item[valueMemberName] == v;
        });


        if (idx >= 0) {
            this.selectedItem = this.state.items[idx];
        }
        else
            this.selectedItem = null;

        this.reportChange(value, this.selectedItem);
    }

    reportChange(value, selectedItem) {
        console.log("## report change, next should go to DM: ", value, this, selectedItem);
        this.dataManager.reportChange(value, this, selectedItem);
        if (this.props.onChange) {
            this.props.onChange(value, selectedItem);
        }
    }

    getItemId(item) {
        var idField = this?.metaData?.dataSourceData?.valueMemberName ? this.metaData.dataSourceData.valueMemberName : 'id';
        return item[idField];
    }

    getItemValue(item) {
        var nameField = this?.metaData?.dataSourceData?.displayMemberName ? this.metaData.dataSourceData.displayMemberName : 'name';
        return item[nameField];
    }

    render() {
        var self = this;
        return (
            <select
                id={this.props.id}
                className={this.isInputValid() ? 'control dropdown valid' : 'control dropdown error'}
                value={this.state.value}
                onChange={this.onChange}
                disabled={!this.state.items || this.state.items.length <= 1 || this.props.disabled === true}>

                {this.state.defaultSelectedId < 1 &&
                    <option value={-1}>Please select...</option>
                }

                {this.state.items.map(function (item, index) {
                    return (<option value={self.getItemId(item)} key={self.getItemId(item) + '_option'}>{self.getItemValue(item)}</option>);
                })}
            </select>
        );
    }
}